export default __webpack_public_path__ + "static/media/Visdag met barbecue.9cb41a5c.jpg";